import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { AppSettings } from 'src/app/app.settings';
import {
  GetMembersParams,
  GroupInterface,
  GroupMemberInterface,
} from '../../interfaces/groups/group.interface';
import { MarketingArchiveStatusFilter } from '../../interfaces/campaigns/campaign.interface';

interface GroupMemberDTO {
  id: string;
  name: string;
  email?: string;
  emailAddress?: string;
}

interface GetItemsByTypeDTO {
  members: GroupMemberDTO[];
  count: number;
  cacheId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class GroupsService {
  constructor(private baseRestAngular: Restangular, private restAngular: Restangular) {
    this.restAngular = this.getCustomRestAngular();
  }

  getCustomRestAngular() {
    return this.baseRestAngular.withConfig((RestangularConfigurer: any) => {
      RestangularConfigurer.setBaseUrl(AppSettings.getMarketingEndpoint());
    });
  }

  getAll(status: MarketingArchiveStatusFilter = 'active'): Promise<GroupInterface[]> {
    return this.restAngular.all('groups').getList({ status }).toPromise();
  }

  getById(groupId: string): Promise<GroupInterface> {
    return this.restAngular.one('groups', groupId).get().toPromise();
  }

  updateById(groupId: string, data: any): Promise<any> {
    return this.restAngular.one('groups', groupId).customPUT(data).toPromise();
  }

  archiveById(groupId: string): Promise<void> {
    return this.restAngular.one('groups', groupId).remove().toPromise();
  }

  removeMemberById(groupId: string, memberId: string): Promise<any> {
    return this.restAngular.one('groups', groupId).one('member', memberId).remove().toPromise();
  }

  addMemberToGroupById(groupId: string, memberId: string): Promise<any> {
    return this.restAngular.one('groups', groupId).customPUT({ memberId }).toPromise();
  }

  async createGroup(
    data: any,
    type: 'team' | 'company' | 'brand' | 'emailAddress' | 'existingUser',
  ): Promise<any> {
    return this.restAngular.one('groups', type).customPOST(data).toPromise();
  }

  async getItemsByType(
    type: Exclude<GroupMemberInterface, 'emailAddresses'>,
    getMembersParams: GetMembersParams,
  ): Promise<{ success: true; data: GetItemsByTypeDTO } | { success: false; error: any }> {
    return this.restAngular
      .one('members', type)
      .customPOST({ ...getMembersParams })
      .toPromise();
  }
}
